<div class="w-100 h-100">
    <div class="row" style="padding-top: 25px; padding-bottom: 25px;">
        <div class="col-md-12">
            <div class="form-row justify-content-between align-items-baseline">
                <div class="col-auto">
                    <label class="header_text mb-3">
                        {{$t('shared.details')}}
                    </label>
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-md-12 pr-0">
            <div class="card card_layout p-4">
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-4 mb-3">
                            <div class="form-group">
                                <label>{{$t('shared.providerName')}}</label>
                                <div class="input-group mb-3">
                                    <input class="form-control" v-model="suggestion.providerName" disabled />
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="form-group">
                                <label>{{$t('shared.serviceName')}}</label>
                                <div class="input-group mb-3">
                                    <input class="form-control" v-model="serviceName" disabled />
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="form-group">
                                <label>{{$t('shared.title')}}</label>
                                <input class="form-control" v-model="suggestion.title" maxlength="30" disabled />
                            </div>
                        </div>
                    </div>

                    <div class="col-md-6 mt-5">
                        <div class="form-group">
                            <label>{{$t('shared.suggestionsAndSystemEnhancement')}}</label>
                            <textarea class="form-control" v-model="suggestion.description" maxlength="500" rows="5" disabled></textarea>
                            <small class="form-text text-muted text-right d-block">
                                {{ suggestion.description.length }} / 500
                            </small>
                        </div>
                    </div>

                    <div class="col-md-12 mt-2">
                        <div class="form-row justify-content-end align-items-center">
                            <div class="col-auto mx-3">
                                <router-link to="/SuggestionsAndSystemEnhancement" tag="a"
                                    class="link_secondary">{{$t('shared.back')}}</router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>